import PageHeader from "@/components/PageHeader";
import LegalLayout from "@/components/LegalLayout";
import { useDocumentSEO } from "@/hooks/useDocumentSEO";

export default function CerezPage() {
  useDocumentSEO({
    title: "Çerez Politikası",
    description:
      "1001 Mimarlık İnşaat ve Ticaret A.Ş. web sitesi çerez politikası. Kullanılan çerez türleri, amaçları ve kullanıcı tercihlerinin yönetimi hakkında bilgi.",
  });
  return (
    <>
      <PageHeader
        breadcrumb="Çerez Politikası"
        overline="Yasal Bilgilendirme"
        title="Çerez Politikası"
      />
      <LegalLayout>
        <p>
          1001 Mimarlık İnşaat ve Ticaret A.Ş. olarak web sitemizi ziyaret
          eden kullanıcılara daha iyi bir deneyim sunabilmek amacıyla sınırlı
          düzeyde çerez (cookie) teknolojileri kullanmaktayız. İşbu politika;
          hangi çerezlerin, hangi amaçla kullanıldığını ve bu çerezleri nasıl
          yönetebileceğinizi açıklamaktadır.
        </p>

        <h2>1. Çerez Nedir?</h2>
        <p>
          Çerezler; ziyaret ettiğiniz web sitelerinin tarayıcınız aracılığıyla
          bilgisayarınıza veya mobil cihazınıza yerleştirdiği küçük metin
          dosyalarıdır. Çerezler; site işlevselliğini sağlamak, kullanım
          tercihlerinizi hatırlamak ve site performansını ölçmek gibi
          amaçlarla kullanılır.
        </p>

        <h2>2. Sitemizde Kullanılan Çerez Türleri</h2>
        <h3>a) Zorunlu Çerezler</h3>
        <p>
          Web sitesinin temel işlevlerinin çalışabilmesi için gerekli olan
          çerezlerdir. Örneğin; çerez tercihinize ilişkin onayın hatırlanması
          bu kapsamdadır. Bu çerezler devre dışı bırakıldığında sitenin bazı
          bölümleri düzgün çalışmayabilir.
        </p>

        <h3>b) İşlevsel Çerezler</h3>
        <p>
          İletişim formlarının doğru çalışması, sayfa görüntüleme
          tercihleriniz ve benzeri temel kullanıcı deneyimi ayarlarını
          desteklemek amacıyla kullanılabilir. Bu çerezler kimliğinizi teşhis
          edici bilgi toplamaz.
        </p>

        <h3>c) Performans / Analitik Çerezler</h3>
        <p>
          Sitemizin nasıl kullanıldığını genel istatistikler düzeyinde
          anlamak, teknik hataları tespit etmek ve iyileştirmeler yapmak
          amacıyla temel ziyaret istatistikleri toplanabilir. Bu veriler
          bireysel değil, toplu ve anonimleştirilmiş biçimde değerlendirilir.
        </p>

        <h2>3. Çerezleri Ne Amaçla Kullanıyoruz?</h2>
        <ul>
          <li>Sitenin doğru ve güvenli çalışmasını sağlamak,</li>
          <li>İletişim formlarının işlevselliğini desteklemek,</li>
          <li>Genel kullanım istatistiklerini anlamak ve içerikleri iyileştirmek,</li>
          <li>Yasal yükümlülüklerimizi (örneğin KVKK onay kaydı) yerine getirmek.</li>
        </ul>
        <p>
          Web sitemizde reklam, hedefleme veya profil oluşturma amaçlı
          takip çerezleri kullanılmamaktadır.
        </p>

        <h2>4. Çerez Tercihlerinizi Nasıl Yönetebilirsiniz?</h2>
        <p>
          Çerez tercihlerinizi dilediğiniz zaman kullandığınız tarayıcının
          ayarları üzerinden yönetebilir; mevcut çerezleri silebilir veya
          gelecekteki çerezleri engelleyebilirsiniz. Aşağıda yaygın
          tarayıcıların çerez yönetim sayfalarına ilişkin genel yönlendirmeler
          yer almaktadır:
        </p>
        <ul>
          <li>Google Chrome: Ayarlar → Gizlilik ve güvenlik → Çerezler ve diğer site verileri</li>
          <li>Mozilla Firefox: Ayarlar → Gizlilik ve Güvenlik → Çerezler ve Site Verileri</li>
          <li>Safari: Tercihler → Gizlilik → Çerezleri Yönet</li>
          <li>Microsoft Edge: Ayarlar → Çerezler ve site izinleri</li>
        </ul>
        <p>
          Zorunlu çerezleri devre dışı bırakmanız hâlinde sitenin bazı
          bölümleri beklendiği gibi çalışmayabilir.
        </p>

        <h2>5. İletişim</h2>
        <p>
          Çerez politikamıza ilişkin soru ve talepleriniz için bizimle{" "}
          <a href="mailto:info@1001insaat.com.tr">info@1001insaat.com.tr</a>{" "}
          adresi üzerinden iletişime geçebilirsiniz.
        </p>

        <p className="legal-note">
          Not: İşbu metin genel bir çerez politikası taslağı niteliğinde
          olup, sitede kullanılan üçüncü taraf hizmet ve teknolojilere göre
          bir hukuk danışmanı tarafından gözden geçirilmesi önerilir.
        </p>
      </LegalLayout>
    </>
  );
}
